import React, { FC } from "react";

type Props = {
  onClick: () => void;
  text: string;
};

const AdvancedSearchLink: FC<Props> = ({ onClick, text }) => (
  <div className="AdvancedSearchLink">
    <a
      data-testid="more-filters-switch"
      onClick={onClick}
      className="text-custom-blue text-base font-semibold cursor-pointer"
    >
      {text}
    </a>
  </div>
);

export default AdvancedSearchLink;
